// Main mock data exports
export * from './types';
export * from './vehicles/used-cars';
export * from './users/profiles';

// API response simulators
export const simulateApiDelay = (ms: number = 500) => 
  new Promise(resolve => setTimeout(resolve, ms));

export const mockApiResponse = <T>(data: T, delay: number = 500) =>
  simulateApiDelay(delay).then(() => ({ data, success: true }));